<template>
  <details ref="menu" class="node-menu" @toggle="handleToggle">
    <summary class="icon-button" title="Add">
      <Plus class="icon" />
    </summary>
    <div class="node-menu-popover">
      <button type="button" class="menu-command" @click="createDocument">
        <FilePlus class="icon" />
        <span>New document</span>
      </button>
      <button type="button" class="menu-command" @click="createFolder">
        <FolderPlus class="icon" />
        <span>New folder</span>
      </button>
    </div>
  </details>
</template>

<script setup lang="ts">
import { FilePlus, FolderPlus, Plus } from 'lucide-vue-next';
import { useNodeMenu } from './useNodeMenu';

const emit = defineEmits<{
  newDocument: [];
  newFolder: [];
}>();

const { menu, closeMenu, handleToggle } = useNodeMenu();

function createDocument(): void {
  closeMenu();
  emit('newDocument');
}

function createFolder(): void {
  closeMenu();
  emit('newFolder');
}
</script>
